var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ProductContext } from "@/shared/presentation/context-api/providers/product";
import { productIconByCode } from "@/shared/utils";
import { HStack, Center, Spinner } from "@reverb-ui/react";
import React from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ProductBox } from "./product-box";
export var EasyAccessUserPlatforms = function (_a) {
    var styleProps = _a.styleProps;
    var t = useTranslation("home").t;
    var _b = useContext(ProductContext), entityWalletPlatforms = _b.entityWalletPlatforms, loadingPlatforms = _b.loading;
    var platforms = entityWalletPlatforms.flat();
    var getPlatformLink = function (externalId) {
        var islink = externalId.includes("/") || externalId.includes(".com");
        var isID = !!(externalId && Number(externalId));
        if (!externalId || !islink || isID) {
            return null;
        }
        var hasHttp = externalId.includes("https") || externalId.includes("http");
        if (!hasHttp) {
            return "https://" + externalId;
        }
        return externalId;
    };
    return (React.createElement(HStack, __assign({}, styleProps, { flexWrap: "wrap" }),
        loadingPlatforms && (React.createElement(Center, { w: "full", p: 12 },
            React.createElement(Spinner, { color: "blue.500" }))),
        !loadingPlatforms &&
            platforms.map(function (platform) {
                var name = platform.name, externalId = platform.externalId, entityPlatformId = platform.entityPlatformId, externalName = platform.externalName;
                var platformName = name.toLowerCase().split(" ")[0];
                var descriptionKey = platformName.includes("studio")
                    ? "products.studio"
                    : "products." + platformName;
                var platformLink = getPlatformLink(externalId);
                return (React.createElement(ProductBox, { key: entityPlatformId, name: externalName || platformName, icon: productIconByCode[platformName], href: platformLink, description: t(descriptionKey) }));
            })));
};
